import {AdminEventTypeEnum} from '../enum/admin-event-type.enum';

/**
 * @class
 * @description This class is used to represent the administrator event that is triggered.
 * @event
 * @export
 * @name AdminEvent
 */
export class AdminEvent {

  /**
   * @constructor
   * @description This constructor creates an instance of the AdminEvent class.
   * @memberof AdminEvent
   * @name AdminEvent#constructor
   * @param {AdminEventTypeEnum} type This parameter contains the type of event that is being triggered.
   * @public
   */
  public constructor(
    /**
     * @description This property contains the type of event that is being triggered.
     * @memberof AdminEvent
     * @name AdminEvent#type
     * @property
     * @public
     * @readonly
     * @type {AdminEventTypeEnum}
     */
    public readonly type: AdminEventTypeEnum
  ) {
  }
}
